<script setup lang="ts">
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';

import ColoredText from '../components/ColoredText.vue';
import DefaultChip from '../components/DefaultChip.vue';
import FinancingSegmentView from '../components/FinancingSegmentView.vue';
import CustomerProfileDisplay from '../components/CustomerProfileDisplay.vue';

import { useCurrentEstimatedSegments } from '../composables/useCurrentEstimatedSegments';

const { financingSegments, regularSegments } = useCurrentEstimatedSegments();
</script>

<template>
  <div>
    <CustomerProfileDisplay />

    <div v-if="financingSegments.length > 0" class="mb-6">
      <div v-for="segment in financingSegments" :key="`financing-${segment.id}`">
        <h2 class="font-bold text-gray-900 text-lg mb-4">Podsumowanie {{ segment.name }}</h2>
        <FinancingSegmentView :segment="segment as any" />
      </div>
    </div>

    <Accordion :value="[0]" multiple>
      <AccordionPanel
        class="mb-3"
        :value="index"
        :key="segment.id"
        v-for="(segment, index) in regularSegments"
      >
        <AccordionHeader>
          <div class="font-bold text-gray-900">Podsumowanie {{ segment.name }}</div>
        </AccordionHeader>
        <AccordionContent>
          <div class="divide-y text-sm text-gray-iron-700">
            <!-- v-for="rule in segment.rules.filter((r) => Number(r.eval) !== 0)" -->
            <div
              :key="rule.id"
              v-for="rule in segment.rules"
              class="flex items-center justify-between py-3.5"
            >
              <ColoredText :variant="rule.color">
                {{ rule.name }}
              </ColoredText>

              <DefaultChip v-tooltip.left="rule.expression" :variant="rule.color">
                {{ rule.eval }}
                {{ rule.unit }}
              </DefaultChip>
            </div>
          </div>

          <div :key="group.id" v-for="group in segment.groups" class="space-y-1">
            <div class="font-bold text-gray-900">{{ group.name }}</div>

            <div class="divide-y text-sm text-gray-iron-700">
              <div
                :key="groupRule.id"
                v-for="groupRule in group.rules"
                class="flex items-center justify-between py-3.5"
              >
                <ColoredText :variant="groupRule.color" class="max-w-40 text-sm">
                  {{ groupRule.name }}
                </ColoredText>

                <DefaultChip v-tooltip.left="groupRule.expression" :variant="groupRule.color">
                  {{ groupRule.eval }}
                  {{ groupRule.unit }}
                </DefaultChip>
              </div>
            </div>
          </div>
        </AccordionContent>
      </AccordionPanel>
    </Accordion>
  </div>
</template>
